import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const MenuBarIcon = React.memo(
  ({
    fill = variables['colors-mc-primary'],
    width = '102',
    height = '113',
    viewBox = '0 0 102 113',
    svgIconPadding = 13
  }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <g transform={'translate(' + svgIconPadding + ',' + svgIconPadding + ')'}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={102 - svgIconPadding * 2}
          height={113 - svgIconPadding * 2}
          viewBox={'0 0 102 113'}
          fill={'none'}
        >
          <path
            d='M69.1333 58.5334C66.8667 64.1334 62.8667 66.4 57 65.7334C53.2667 65.3334 52.2 65.8667 50.3333 68.9334C48.3333 72.5334 48.3333 72.9334 50.8667 76.1334C52.4667 78.1334 53.6667 81.3334 53.6667 83.3334C53.6667 85.3334 52.4667 88.5334 50.8667 90.5334C48.3333 93.7334 48.3333 94.1334 50.3333 97.7334C52.2 100.8 53.2667 101.333 57 100.933C62.8667 100.267 66.8667 102.533 69.1333 108.133C70.7333 111.867 71.8 112.667 75 112.667C78.2 112.667 79.2667 111.867 80.8667 108.133C83.1333 102.533 87.1333 100.267 93 100.933C96.7333 101.333 97.8 100.8 99.6667 97.7334C101.667 94.1334 101.667 93.7334 99.1333 90.5334C95.5333 86 95.5333 80.6667 99.1333 76.1334C101.667 72.9334 101.667 72.5334 99.6667 68.9334C97.8 65.8667 96.7333 65.3334 93 65.7334C87.1333 66.4 83.1333 64.1334 80.8667 58.5334C79.2667 54.8 78.2 54 75 54C71.8 54 70.7333 54.8 69.1333 58.5334ZM80.3333 78C81.8 79.4667 83 81.8667 83 83.3334C83 86.8 78.4667 91.3334 75 91.3334C73.5333 91.3334 71.1333 90.1334 69.6667 88.6667C68.2 87.2 67 84.8 67 83.3334C67 81.8667 68.2 79.4667 69.6667 78C71.1333 76.5334 73.5333 75.3334 75 75.3334C76.4667 75.3334 78.8667 76.5334 80.3333 78Z'
            fill={fill}
          />
          <path
            d='M4.06669 68.6667C0.333352 72.4 0.0666855 73.3334 0.600019 80C1.26669 88.5334 5.66668 94.9334 14.0667 99.8667C21.2667 104.133 33.6667 107.333 42.6 107.333H49.8L46.8667 103.467C44.4667 100.267 42.8667 99.6 35.9334 98.8C19.4 97.0667 7.80002 88.2667 8.60002 78L9.00002 73.3334L25.2667 72.9334L41.6667 72.5334L43.6667 68.6667L45.8 64.6667H26.8667H8.06669L4.06669 68.6667Z'
            fill={fill}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M41 54C55.9117 54 68 41.9117 68 27C68 12.0883 55.9117 0 41 0C26.0883 0 14 12.0883 14 27C14 41.9117 26.0883 54 41 54ZM41 46C51.4934 46 60 37.4934 60 27C60 16.5066 51.4934 8 41 8C30.5066 8 22 16.5066 22 27C22 37.4934 30.5066 46 41 46Z'
            fill={fill}
          />
        </svg>
      </g>
    </svg>
  )
);
MenuBarIcon.displayName = 'MenuBarIcon';

export default MenuBarIcon;
